"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var spaui_1 = require("@tencent/spaui");
var classnames_1 = __importDefault(require("classnames"));
var od_icon_1 = __importDefault(require("@tencent/od-icon"));
var info_1 = __importDefault(require("./info"));
var useChipBase = function useChipBase(_a) {
  var active = _a.active,
    disabled = _a.disabled,
    onClick = _a.onClick;
  var _b = __read((0, react_1.useState)(active !== null && active !== void 0 ? active : false), 2),
    currentActive = _b[0],
    setCurrentActive = _b[1];
  (0, react_1.useEffect)(function () {
    if (active === undefined) return;
    setCurrentActive(active);
  }, [active]);
  // 点击事件
  var handlerClick = (0, react_1.useCallback)(function (e) {
    if (disabled) return; // 禁用情况，没有点击事件
    if (active === undefined) {
      // 未传递 active 用组件内部
      setCurrentActive(function (currentActive) {
        return !currentActive;
      });
    } else {
      onClick === null || onClick === void 0 ? void 0 : onClick(e, !active);
    }
  }, [onClick, active, disabled]);
  return {
    currentActive: currentActive,
    handlerClick: handlerClick
  };
};
var PullDownChipComponent = function PullDownChipComponent(_a, ref) {
  var _b;
  var className = _a.className,
    text = _a.text,
    desc = _a.desc,
    icon = _a.icon,
    _c = _a.chipSize,
    chipSize = _c === void 0 ? 'small' : _c,
    _d = _a.type,
    type = _d === void 0 ? 'primary' : _d,
    _e = _a.mode,
    mode = _e === void 0 ? 'outlined' : _e,
    active = _a.active,
    _f = _a.needArrow,
    needArrow = _f === void 0 ? true : _f,
    _g = _a.needRotateArrow,
    needRotateArrow = _g === void 0 ? true : _g,
    disabled = _a.disabled,
    onClick = _a.onClick,
    onClose = _a.onClose,
    children = _a.children,
    resetProps = __rest(_a, ["className", "text", "desc", "icon", "chipSize", "type", "mode", "active", "needArrow", "needRotateArrow", "disabled", "onClick", "onClose", "children"]);
  var _h = useChipBase({
      disabled: disabled,
      active: active,
      onClick: onClick
    }),
    currentActive = _h.currentActive,
    handlerClick = _h.handlerClick;
  // 删除事件
  var handlerClose = (0, react_1.useCallback)(function (e) {
    e.stopPropagation();
    if (!onClose) return;
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  }, [onClose]);
  var currentIcon = (0, react_1.useMemo)(function () {
    switch (icon) {
      case 'filter':
        {
          return react_1["default"].createElement("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, react_1["default"].createElement("path", {
            d: "M5.6875 2.1875V11.8125L3.0625 9.1875",
            stroke: "currentColor",
            strokeWidth: "0.875",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), react_1["default"].createElement("path", {
            d: "M8.3125 11.8125L8.3125 2.1875L10.9375 4.8125",
            stroke: "currentColor",
            strokeWidth: "0.875",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }));
        }
      case true:
      case 'pull':
        {
          return react_1["default"].createElement(od_icon_1["default"], {
            style: {
              width: 14,
              height: 14
            },
            name: 'add-bold-oulined'
          });
        }
      default:
        return icon;
    }
  }, [icon]);
  return react_1["default"].createElement(spaui_1.Button, __assign({
    baseClass: "odc-pull-down-chip",
    className: (0, classnames_1["default"])((_b = {
      active: currentActive,
      disabled: disabled
    }, _b[chipSize] = true, _b[mode] = true, _b.needRotateArrow = needRotateArrow, _b[type] = true, _b), className),
    onClick: handlerClick
  }, resetProps, {
    htmlRef: ref
  }), react_1["default"].createElement("div", {
    className: 'flex items-center odc-pull-down-chip-icon'
  }, currentIcon), desc && react_1["default"].createElement("span", {
    className: 'odc-pull-down-chip-desc'
  }, desc), react_1["default"].createElement("span", {
    className: 'odc-pull-down-chip-text'
  }, text), children, needArrow && react_1["default"].createElement(od_icon_1["default"], {
    className: 'odc-pull-down-chip-icon arrow',
    style: {
      width: 12,
      height: 12
    },
    name: 'down-medium-outlined'
  }), onClose && react_1["default"].createElement(od_icon_1["default"], {
    className: 'odc-pull-down-chip-close-icon',
    name: 'close-bold-outlined',
    style: {
      width: 12,
      height: 12
    },
    onClick: handlerClose
  }));
};
(0, spaui_utils_1.setComponentMark)(PullDownChipComponent, info_1["default"]);
exports["default"] = react_1["default"].memo((0, react_1.forwardRef)(PullDownChipComponent));